import React from 'react';
import cn from 'classnames';

import { Icon } from 'components/shared/Icon';
import { Typography } from 'components/shared/Typography';

import { idxMap } from 'helpers/styleMapIdx';

import styles from './TypesSelect.module.scss';

const SIZES = {
  md: styles.md,
  lg: styles.lg,
};

const TypesSelect = ({
  options,
  size,
  onOptionClick,
}: {
  options: any;
  size: any;
  onOptionClick: any;
}) => (
  <div
    className={cn(styles.select, idxMap(SIZES as Record<string, string>, size))}
  >
    {options.map((option: any) => (
      <div
        className={styles.option}
        key={option.text}
        onClick={() => onOptionClick(option)}
      >
        <Icon className={styles.optionIcon} name={option.icon} />
        <Typography
          className={styles.optionText}
          variant="body1"
          weight="medium"
          mode="compact"
        >
          {option.text}
        </Typography>
      </div>
    ))}
  </div>
);

TypesSelect.defaultProps = {
  size: 'lg',
};

export default React.memo(TypesSelect) as any;
